import { Button, Col, message, Row, Upload, UploadProps } from "antd";
import { InputBox } from "../../../../../../components/AntdAddons";
import { useEffect, useState } from "react";
import { validations } from "../../../../../../config/validations/validations";
import { UploadOutlined } from "@ant-design/icons";

const CareerCompass: React.FC<any> = ({ form, sectionDetails }) => {
  const [isVisible, setIsVisible] = useState<boolean>(
    sectionDetails?.show_popup_video === "1" ? true : false
  );
  useEffect(() => {
    setIsVisible(sectionDetails?.show_popup_video === "1" ? true : false);
  }, [sectionDetails?.show_popup_video]);




  const checkFileType = (file: any) => {
    const acceptedFormats = [
      "application/pdf",
    ];
    if (!acceptedFormats.includes(file.type)) {
      message.error(`Upload valid pdf`);
      return true;
    } else {
      return false;
    }
  };

  const onPreview = async (file?: any) => {
    // window.open(WebConstant?.IMAGE_URL + pageSettings?.career_compass?.cc_hint_document, '_blank');
    // const getBase64 = (file: any) =>
    //   new Promise((resolve, reject) => {
    //     const reader = new FileReader();
    //     reader.readAsDataURL(file);
    //     reader.onload = () => resolve(reader.result as string);
    //     reader.onerror = (error) => reject(error);
    //   });
    if (!file.url && !file.preview) {
    
      // file.preview = await getBase64(file.originFileObj as any);
    }
    else
    {
      window.open(file.url, '_blank');
    }
  
    //   setPreviewImage(file.url || (file.preview as string));
    //   setPreviewOpen(true);
  };


  return (
    <>
      <Row gutter={15}>
        <Col xs={{ span: 24 }} md={{ span: 12 }} >
          <InputBox.ImageUpload
            required
            beforeUpload={checkFileType}
            imageUrl={sectionDetails?.cc_hint_document}
            name="cc_hint_document"
            label="Hint Document"
            accept=".pdf"
            onPreview={onPreview}
          />
        </Col>
        <Col xs={{ span: 24 }} md={{ span: 12 }} >
          <InputBox.ImageUpload
            required
            beforeUpload={checkFileType}
            imageUrl={sectionDetails?.cc_hint_document_spanish}
            name="cc_hint_document_spanish"
            label="Hint Document (Spanish)"
            accept=".pdf"
            onPreview={onPreview}
          />
        </Col>
        <Col xs={{ span: 24 }} md={{ span: 12 }}>
          <InputBox.Text  name="compass_video_youtube_url" label="Youtube Url" />
        </Col>
        {/* <Col xs={{ span: 24 }} md={{ span: 12 }}>
          <InputBox.Text
            name="video_popup_confirmation_message"
            label={"video_popup_confirmation_message".toTitleCase()}
            rules={[
              validations.required.text(),
              validations.min.text(3),
              validations.max.text(400),
            ]}
          />
        </Col> */}
      </Row>
    </>
  );
};

export default CareerCompass;
